import React from 'react';
import { getLocalizedUserRoleDisplayName } from '../utils/userRoles';
import { useLocale } from '../context/DynamicLocaleProvider';
import styles from './ProfileCard.module.css';

interface ProfileCardProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  avatar?: string;
  status?: 'invited' | 'active' | 'blocked' | 'archive';
  role?: string;
  isDarkMode?: boolean;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({
  firstName,
  lastName,
  email,
  avatar,
  status = 'active',
  role,
  isDarkMode = false
}) => {
  const { t } = useLocale();
  const displayName = firstName && lastName
    ? `${firstName} ${lastName}`
    : (firstName || lastName || email || 'User Profile');

  return (
    <div className={styles.profileCard}>
      <div className={styles.profileAvatar}>
        {avatar ? (
          <img
            src={avatar}
            alt={`${displayName} Avatar`}
            width={80}
            height={80}
            className={styles.avatarImage}
          />
        ) : (
          <div className={styles.defaultAvatar}>
            <img
              src={isDarkMode ? "/assets/icons/person.svg" : "/assets/icons/person.black.svg"}
              alt="User Avatar"
              width={32}
              height={32}
            />
          </div>
        )}
      </div>
      <div className={styles.profileInfo}>
        <h2 className={styles.profileName}>
          {displayName}
        </h2>
        <p className={styles.profileEmail}>
          {email ? (
            <a href={`mailto:${email}`} className={styles.emailLink}>
              {email}
            </a>
          ) : (
            'No email'
          )}
        </p>
        <div className={styles.profileStatusWrapper}>
          <div className={styles.profileStatus}>
            <span className={`${styles.statusBadge} ${styles[status]}`}>
              {status === 'active' ? t('status_active') :
                status === 'invited' ? t('status_invited') :
                  status === 'blocked' ? t('status_blocked') :
                    t('status_archive')}
            </span>
          </div>

          {role && (
            <div className={styles.roleBadge}>
              <img src="/assets/icons/apple.intelligence.green.svg" alt="Badge" width={16} height={16} />
              <span>{getLocalizedUserRoleDisplayName(role, t)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
